import React from 'react';

export const WhyDriveHR = () => {
  return (
    <section className="py-8 bg-white" data-testid="why-drivehr-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-testid="why-drivehr-heading">
            Why DriveHR
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="why-drivehr-text">
            Built by HR professionals with 15+ years of experience supporting businesses across 12+ industries.
          </p>
        </div>
      </div>
    </section>
  );
};
